import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";

// Soft UI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Helper to format date
function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleString("ro-RO", { dateStyle: "short", timeStyle: "short" });
}

// Helper to build action description
function buildAction(item) {
  const changes = [];
  if (item.diff) {
    if (item.diff.status) {
      changes.push(
        `Status: ${item.diff.status.old} → ${item.diff.status.new}`
      );
    }
    if (item.diff.institution_entity) {
      changes.push(
        `Instituție: ${item.diff.institution_entity.old} → ${item.diff.institution_entity.new}`
      );
    }
  }
  if (item.redirect_reason) {
    changes.push(`Redirecționare: ${item.redirect_reason}`);
  }
  if (changes.length === 0 && item.status) {
    changes.push(`Status: ${item.status}`);
  }
  return changes.join(" | ");
}

export default function ReportHistory({ timeline, isMobile }) {
  return (
    <SoftBox p={2}>
      <SoftBox 
        p={2} 
        border="1px solid #eee" 
        borderRadius="lg" 
        bgcolor="#f8f9fa"
      >
        <SoftTypography variant="subtitle2" fontWeight="medium" mb={2}>
          Istoric acțiuni / jurnal de procesare
        </SoftTypography>
        <SoftBox sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {timeline.map((item, index) => (
            <SoftBox
              key={item.history_id || index}
              sx={{ display: "flex", alignItems: "center", flexWrap: isMobile ? "wrap" : "nowrap" }}
            >
              <SoftBox 
                sx={{ 
                  width: 8, 
                  height: 8, 
                  borderRadius: "50%", 
                  bgcolor: "info.main",
                  mr: 1.5,
                  flexShrink: 0
                }} 
              />
              <SoftTypography
                variant="caption"
                fontWeight="medium"
                width={isMobile ? "100%" : "120px"}
                sx={{ mb: isMobile ? 0.5 : 0 }}
              >
                {formatDate(item.created_at)}
              </SoftTypography>
              <SoftTypography variant="body2" sx={{ ml: 1 }}>
                {buildAction(item)}
              </SoftTypography>
              {item.history_user && (
                <SoftTypography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
                  <Icon fontSize="small" sx={{ verticalAlign: "middle", mr: 0.5 }}>person</Icon>
                  {item.history_user}
                </SoftTypography>
              )}
            </SoftBox>
          ))}
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

ReportHistory.propTypes = {
  timeline: PropTypes.arrayOf(
    PropTypes.shape({
      history_id: PropTypes.number,
      status: PropTypes.string,
      institution_entity: PropTypes.string,
      redirect_reason: PropTypes.string,
      created_at: PropTypes.string,
      history_type: PropTypes.string,
      history_user: PropTypes.string,
      diff: PropTypes.object
    })
  ).isRequired,
  isMobile: PropTypes.bool
};
